module.exports = __webpack_public_path__ + "static/media/cash.3d90b089.svg";